import { useReactQueryDevTools } from '@dev-plugins/react-query';
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import * as React from 'react';

export const queryClient: QueryClient = new QueryClient({
  mutationCache: new MutationCache({
    // eslint-disable-next-line max-params
    onSuccess: (_data, _variables, _context, mutation) => {
      if (mutation.meta?.skipInvalidate) return;

      queryClient.invalidateQueries();
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
});

export function APIProvider({ children }: { children: React.ReactNode }) {
  useReactQueryDevTools(queryClient);
  return (
    // Provide the client to your App
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
